// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
// import Header from "./main/header";
// import Nav from "./main/nav";
// import Footer from "./main/footer";

// const containerStyle = {
//     width: "96%",
//     height: "70vh",
// };

// const center = {
//     lat: 28.5116,
//     lng: 77.2878,
// };

// const LiveItvTracking = () => {
//     const [equipments, setEquipments] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const { isLoaded } = useJsApiLoader({
//         googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c", // Replace with your actual API key
//     });

//     useEffect(() => {
//         GetData();
//     }, []);

//     const GetData = async () => {
//         setLoading(true);
//         try {
//             const response = await axios.get("https://ctas.ai/backend/api/get/itv/location");
//             setEquipments(response.data.data); // Use the new API structure
//         } catch (error) {
//             console.error("Error fetching ITV location data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const CustomMarker = ({ position, number }) => {
//         return (
//             <OverlayView
//                 position={position}
//                 mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
//             >
//                 <div
//                     style={{
//                         position: "relative",
//                         width: "80px",
//                         height: "50px",
//                         backgroundImage: "url(/rst.png)",
//                         backgroundSize: "cover",
//                         textAlign: "center",
//                         lineHeight: "50px",
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                         color: "white",
//                         borderRadius: "5%",
//                         border: "2px solid blue",
//                     }}
//                 >
//                     {number}
//                 </div>
//             </OverlayView>
//         );
//     };

//     if (!isLoaded) return <p>Loading map...</p>;

//     return (
//         <div className="layout-wrapper layout-content-navbar">
//             <div className="layout-container">
//                 <Header />
//                 <div className="layout-page">
//                     <Nav />
//                     <div className="content-wrapper">
//                         <div className="row">
//                             <div className="col-md-4">

//                                 <h4 className="text-center text-primary">Vehicles List</h4>

//                                 <div className="card">
//                                     <div className="card-body px-1">
//                                         <div className="table-responsive text-nowrap">
//                                             <table className="table table-hover table-font table-striped">
//                                                 <thead>
//                                                     <tr className="table-primary">
//                                                         <th>S.No.</th>
//                                                         <th>Vehicle No</th>
//                                                         <th>Current Lat/Lng</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {equipments?.map((equipment, i) => (
//                                                         <tr key={equipment.id}>
//                                                             <td>{i + 1}</td>
//                                                             <td>{equipment.vehicleno}</td>
//                                                             <td>
//                                                                 {equipment.last_location?.latitude}, {equipment.last_location?.longitude}
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="col-md-8">
//                                 <h4 className="text-center text-primary">Vehicle Locations</h4>
//                                 <GoogleMap
//                                     mapContainerStyle={containerStyle}
//                                     center={center}
//                                     zoom={17.5}
//                                     mapTypeId="satellite"
//                                 >
//                                     {equipments.map((equipment) => {
//                                         const location = equipment.last_location;
//                                         if (!location) return null;

//                                         return (
//                                             <CustomMarker
//                                                 key={equipment.id}
//                                                 position={{
//                                                     lat: parseFloat(location.latitude),
//                                                     lng: parseFloat(location.longitude),
//                                                 }}
//                                                 number={equipment.vehicleid}
//                                             />
//                                         );
//                                     })}
//                                 </GoogleMap>
//                             </div>
//                         </div>

//                         <Footer />
//                         <div className="content-backdrop fade" />
//                     </div>
//                 </div>
//             </div>
//             <div className="layout-overlay layout-menu-toggle"></div>
//             <div className="drag-target"></div>
//         </div>
//     );
// };

// export default LiveItvTracking;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { GoogleMap, useJsApiLoader, OverlayView } from "@react-google-maps/api";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import { Polyline } from "@react-google-maps/api";
import { Marker } from "@react-google-maps/api";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./LiveItv.css"; // Import your CSS file for styling



const containerStyle = {
  width: "96%",
  height: "70vh",
};

const center = {
  lat: 28.5116,
  lng: 77.2878,
};

const LiveItvTracking = () => {
  const [equipments, setEquipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fromTime, setFromTime] = useState(new Date());
  const [toTime, setToTime] = useState(new Date());

  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehiclePath, setVehiclePath] = useState([]);


  const handleFilter = async () => {
    if (!selectedDate || !fromTime || !toTime) {
      alert("Please select date and both times.");
      return;
    }
    openVehicleRoute(selectedVehicle, selectedDate, fromTime, toTime);
  };





  const openVehicleRoute = async (vehicle, date = null, fromStr = null, toStr = null) => {
    setSelectedVehicle(vehicle);
    setShowModal(true);

    try {
      let url = `https://ctas.ai/backend/api/get/itv/location?id=${vehicle.id}`;

      // if (fromStr && toStr && date) {
      //   const dateStr = new Date(date).toISOString().split("T")[0]; // "YYYY-MM-DD"
      //   const startStr = `${dateStr}T${fromStr}:00`;
      //   const endStr = `${dateStr}T${toStr}:00`;
      //   url += `&date=${dateStr}&start=${startStr}&end=${endStr}`;
      // }
      if (date) {
        url += `&date=${date}`;
      }
      if (fromStr) {
        url += `&start=${fromStr}`;
      }
      if (toStr) {
        url += `&end=${toStr}`;
      }

      const response = await axios.get(url);
      console.log("API vehicle history response:", response.data);

      const history = response.data.history;
      if (Array.isArray(history)) {
        setVehiclePath(history);
      } else {
        setVehiclePath([]);
      }
    } catch (error) {
      console.error("Failed to load route:", error);
      setVehiclePath([]);
    }
  };






  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c",
  });

  useEffect(() => {
    GetData(); // Initial fetch without filter
  }, []);

  const GetData = async (from = "", to = "") => {
    setLoading(true);
    try {
      let url = "https://ctas.ai/backend/api/get/itv/location";
      if (from && to) {
        url += `?from_datetime=${encodeURIComponent(from)}&to_datetime=${encodeURIComponent(to)}`;
      }
      const response = await axios.get(url);
      setEquipments(response.data.data || []);
    } catch (error) {
      console.error("Error fetching ITV location data:", error);
    } finally {
      setLoading(false);
    }
  };


  const CustomMarker = ({ position, number }) => {
    return (
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <div
          style={{
            position: "relative",
            width: "80px",
            height: "50px",
            backgroundImage: "url(/rst.png)",
            backgroundSize: "cover",
            textAlign: "center",
            lineHeight: "50px",
            fontSize: "14px",
            fontWeight: "bold",
            color: "white",
            borderRadius: "5%",
            border: "2px solid blue",
          }}
        >
          {number}
        </div>
      </OverlayView>
    );
  };

  if (!isLoaded) return <p>Loading map...</p>;

  return (



    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="row">

              {showModal && (
                <div className="custom-modal-overlay">
                  <div className="custom-modal">
                    <div className="modal-header">
                      <h3>{selectedVehicle?.vehicleno} - Movement History</h3>
                      <button
                        className="modal-close-btn"
                        onClick={() => {
                          setShowModal(false);
                          setVehiclePath([]);
                        }}
                      >
                        ×
                      </button>
                    </div>

                    <div className="modal-body">
                      <div className="input-row">
                        <div className="input-group">
                          <label>Date</label>
                          <input
                            type="date"
                            onChange={(e) => setSelectedDate(e.target.value)}
                          />
                        </div>
                        <div className="input-group">
                          <label>From Time</label>
                          <input
                            type="time"
                            onChange={(e) => setFromTime(e.target.value)}
                          />
                        </div>
                        <div className="input-group">
                          <label>To Time</label>
                          <input
                            type="time"
                            onChange={(e) => setToTime(e.target.value)}
                          />
                        </div>
                        <button className="apply-btn" onClick={handleFilter}>
                          Apply
                        </button>
                      </div>

                      <div className="map-box">
                        <GoogleMap
                          mapContainerStyle={{ width: "100%", height: "400px" }}
                          center={{
                            lat: vehiclePath.length ? parseFloat(vehiclePath[0].latitude) : center.lat,
                            lng: vehiclePath.length ? parseFloat(vehiclePath[0].longitude) : center.lng,
                          }}

                          zoom={17}
                          mapTypeId="satellite"
                        >
                          {vehiclePath.map((loc, idx) => {
                            const isLast = idx === vehiclePath.length - 1;
                            const lat = parseFloat(loc.latitude);
                            const lng = parseFloat(loc.longitude);

                            return isLast ? (
                              <OverlayView
                                key={idx}
                                position={{ lat, lng }}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "80px",
                                    height: "50px",
                                    backgroundImage: "url(/rst.png)",
                                    backgroundSize: "cover",
                                    textAlign: "center",
                                    lineHeight: "50px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "white",
                                    borderRadius: "5%",
                                    border: "2px solid blue",
                                  }}
                                >
                                  {selectedVehicle?.vehicleid}
                                </div>
                              </OverlayView>
                            ) : (
                              <Marker
                                key={idx}
                                position={{ lat, lng }}
                                icon={{
                                  url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                                  scaledSize: new window.google.maps.Size(10, 10),
                                }}
                              />
                            );
                          })}

                          {vehiclePath.length > 1 && (
                            <Polyline
                              path={vehiclePath.map((loc) => ({
                                lat: parseFloat(loc.latitude),
                                lng: parseFloat(loc.longitude),
                              }))}
                              options={{
                                strokeColor: "#00BFFF",
                                strokeOpacity: 0.8,
                                strokeWeight: 4,
                              }}
                            />
                          )}
                        </GoogleMap>
                      </div>
                    </div>
                  </div>
                </div>
              )}







              <div className="col-md-4">
                <h4 className="text-center text-primary">Vehicles List</h4>
                <div className="card">
                  <div className="card-body px-1">
                    <div className="table-responsive text-nowrap">
                      {loading ? (
                        <div className="text-center my-3">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Loading vehicle data...</p>
                        </div>
                      ) : (
                        <table className="table table-hover table-font table-striped">
                          <thead>
                            <tr className="table-primary">
                              <th>S.No.</th>
                              <th>Vehicle No</th>
                              <th>Current Lat/Lng</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            {equipments?.map((equipment, i) => (
                              <tr key={equipment.id}>
                                <td>{i + 1}</td>
                                <td>{equipment.vehicleno}</td>
                                <td>
                                  {equipment?.latitude},{" "}
                                  {equipment?.longitude}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    disabled={loading}
                                    onClick={() => openVehicleRoute(equipment)}
                                  >
                                    Map
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}

                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-8">
                <h4 className="text-center text-primary">Vehicle Locations</h4>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={17.5}
                  mapTypeId="satellite"
                >
                  {equipments.map((equipment) => {
                    const location = equipment;
                    if (!location) return null;

                    return (
                      <CustomMarker
                        key={equipment.id}
                        position={{
                          lat: parseFloat(location.latitude),
                          lng: parseFloat(location.longitude),
                        }}
                        number={equipment.vehicleid}
                      />
                    );
                  })}
                </GoogleMap>
              </div>
            </div>

            <Footer />
            <div className="content-backdrop fade" />
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default LiveItvTracking;

